import React, { useState } from "react";
import "./header.css";
import "../../common/navbar.css";
import {
  Layout,
  Menu,
  Dropdown,
  Modal,
  Button,
  Affix,
  Form,
  Input,
  Checkbox,
} from "antd";
import "antd/dist/antd.css";
import {
  SearchOutlined,
  UserOutlined,
  UnorderedListOutlined,
  ShoppingCartOutlined,
  FacebookOutlined,
  WhatsAppOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  MenuFoldOutlined,
  HomeOutlined,
  CloseOutlined,
  LoginOutlined,
  LockOutlined,
} from "@ant-design/icons";

import { Link } from "react-router-dom";

const Header = (props) => {
  const secondMenu = (
    <Menu style={{ borderRadius: "5px", padding: "10px" }}>
      <Menu.Item key="0">
        <a className="dropdownlink" href="#">
          <UserOutlined />
          Contructors
          <p className="dropdownPara">Hire professionals and agencies</p>
        </a>
      </Menu.Item>
      <Menu.Item key="1">
        <a className="dropdownlink" href="#">
          <UnorderedListOutlined />
          Builders
          <p className="dropdownPara">Buy pre-defined projects</p>
        </a>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="3">
        <a className="dropdownlink" href="#">
          <ShoppingCartOutlined />
          Engineers
          <p className="dropdownPara">Apply to jobs posted by clients</p>
        </a>
      </Menu.Item>
      <Menu.Item key="4">
        <a className="dropdownlink" href="#">
          <ShoppingCartOutlined />
          Suppliers
          <p className="dropdownPara">Apply to jobs posted by clients</p>
        </a>
      </Menu.Item>
    </Menu>
  );

  const thirdMenu = (
    <Menu style={{ borderRadius: "5px", padding: "10px" }}>
      <Menu.Item key="0">
        <a className="dropdownlink" href="#">
          <UserOutlined className="socialMediaIcons" /> Profile
        </a>
      </Menu.Item>
      <Menu.Item key="1">
        <a className="dropdownlink" href="#">
          <UnorderedListOutlined />
          History
          <p className="dropdownPara">Buy pre-defined projects</p>
        </a>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="3">
        <a className="dropdownlink" href="#">
          <ShoppingCartOutlined />
          Setting
          <p className="dropdownPara">Apply to jobs posted by clients</p>
        </a>
      </Menu.Item>
    </Menu>
  );

  const contentStyle = {
    height: "70vh",
    color: "#fff",
    lineHeight: "50px",
    backgroundColor: "#364d79",
  };

  const toggleNav = () => {
    var navToggle = document.getElementById("navToggle");

    navToggle.style.display = "block";
  };

  const isClose = () => {
    var navToggle = document.getElementById("navToggle");

    navToggle.style.display = "none";
  };

  const [top, setTop] = useState(0);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
    setIsModalVisible2(false);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showModal2 = () => {
    setIsModalVisible2(true);
    setIsModalVisible(false);
  };

  const handleOk2 = () => {
    setIsModalVisible2(false);
  };

  const handleCancel2 = () => {
    setIsModalVisible2(false);
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
  };

  return (
    <div>
      {/* Navbar Section */}
      <section>
        <Layout>
          <div>
            <div className="container d-flex">
              <div id="icons">
                <div className="icon">
                  <a target="_blank" href={props.facebookLink}>
                    <FacebookOutlined className="socialMediaIcons" />
                  </a>
                  <p className="icon-text">Facebook</p>
                </div>
                <div className="icon">
                  <a
                    target="_blank"
                    href="https://api.whatsapp.com/send?phone=923554508231&app=facebook&entry_point=page_cta&fbclid=IwAR1MCKjzaC6SY98V11z_bWX-HzzoJHmP5Yt6Jvv44nvr94SsQSxezWFFtu8"
                  >
                    <WhatsAppOutlined className="socialMediaIcons" />
                  </a>
                  <p className="icon-text">Whatsapp</p>
                </div>
                <div className="icon">
                  <a href="#">
                    <LinkedinOutlined className="socialMediaIcons" />
                  </a>
                  <p className="icon-text">Linkedin</p>
                </div>
                <div className="icon">
                  <a href="#">
                    <InstagramOutlined className="socialMediaIcons" />
                  </a>
                  <p className="icon-text">Instagram</p>
                </div>
              </div>
              <div className="brand">
                {/* <Link to="/"> */}
                <a href="#">
                  <img
                    src={props.brandLogo}
                    className="brandLogo"
                    width="120"
                    alt="Broshall logo"
                  />
                  <p className="brandPara">{props.brandName}</p>
                </a>
                {/* </Link> */}
              </div>
              <div id="icons">
                <div className="icon">
                  <span className="cartSpan">0</span>
                  <a href="#">
                    <ShoppingCartOutlined className="socialMediaIcons" />
                  </a>
                  <p className="icon-text">Cart</p>
                </div>
                <div className="icon">
                  <a href="#">
                    <LoginOutlined
                      className="socialMediaIcons"
                      onClick={showModal}
                    />
                  </a>
                  <p className="icon-text">Login</p>
                </div>
                <Dropdown overlay={thirdMenu} trigger={["click"]}>
                  <div className="icon">
                    <a href="#">
                      <UserOutlined
                        className="socialMediaIcons"
                        onClick={(e) => e.preventDefault()}
                      />
                    </a>
                    <p className="icon-text">Profile</p>
                  </div>
                </Dropdown>
              </div>
            </div>
          </div>
        </Layout>
        <Layout>
          <div className="scrollable-container">
            <Affix offsetTop={top}>
              <div className="header">
                <div className="head">
                  <div
                    className="container"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Menu
                      className="navbar"
                      mode="horizontal"
                      defaultSelectedKeys={[""]}
                      id="nav"
                    >
                      <Menu.Item className="navItem" key="1">
                        <Link to="/">Home</Link>
                      </Menu.Item>
                      <Menu.Item className="navItem" key="2">
                        <Link to="/fishfarm">Trout Fish</Link>
                      </Menu.Item>
                      <Menu.Item className="navItem" key="3">
                        <Dropdown overlay={secondMenu} trigger={["hover"]}>
                          <a
                            className="ant-dropdown-link"
                            onClick={(e) => e.preventDefault()}
                          >
                            Services
                          </a>
                        </Dropdown>
                      </Menu.Item>
                      <Menu.Item className="navItem" key="4">
                        <Link to="/poultory">Poultary</Link>
                      </Menu.Item>
                      <Menu.Item className="navItem" key="5">
                        <Link to="/associates">Associates</Link>
                      </Menu.Item>
                      {/* <Menu.Item className="navItem" key="6">
                        <Link to="/hotels">Hotels</Link>
                      </Menu.Item> */}
                    </Menu>

                    <div className="logo">
                      <div className="searchFeild">
                        <input type="text" placeholder="Search here ..." />
                        <SearchOutlined style={{ color: "gray" }} />
                      </div>
                    </div>
                    <Button className="toggleBtn" onClick={toggleNav}>
                      <MenuFoldOutlined />
                    </Button>
                  </div>
                </div>
              </div>
            </Affix>
          </div>
        </Layout>
      </section>

      <section id="navToggle">
        <div>
          <Button id="cross" onClick={isClose}>
            <CloseOutlined />
          </Button>
          <Menu style={{ borderRadius: "5px", marginTop: "35px" }}>
            <Link to="/">
              <Menu.Item key="0">
                <a className="dropdownlink" href="#home">
                  <HomeOutlined />
                  Home
                </a>
              </Menu.Item>
            </Link>
            <Link to="/fishfarm">
              <Menu.Item key="1">
                <a className="dropdownlink" href="#aboutus">
                  <UnorderedListOutlined />
                  Trout Fish
                </a>
              </Menu.Item>
            </Link>
            <Menu.Divider />
            <Menu.Item key="3">
              <Dropdown
                overlay={secondMenu}
                trigger={["hover"]}
                className="services"
              >
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                >
                  <UserOutlined />
                  Services
                </a>
              </Dropdown>
            </Menu.Item>
            <Menu.Divider />
            <Link to="/poultory">
              <Menu.Item key="4">
                <a className="dropdownlink" href="#aboutus">
                  <UnorderedListOutlined />
                  Poultary Farms
                </a>
              </Menu.Item>
            </Link>
            <Link to="/associates">
              <Menu.Item key="5">
                <a className="dropdownlink" href="#aboutus">
                  <UnorderedListOutlined />
                  Broshall Associates
                </a>
              </Menu.Item>
            </Link>
            <Menu.Divider />
          </Menu>
        </div>
      </section>

      {/* sign in modal */}

      <Modal
        id="loginModal"
        title="Log in"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          {...layout}
          name="basic"
          style={{}}
          initialValues={{ remember: true }}
          // onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          className="loginForm"
        >
          <Form.Item
            // label="Username"
            style={{ display: "block" }}
            name="username"
            rules={[{ required: true, message: "Please input your username!" }]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              type="text"
              placeholder="Username"
              className="loginINput"
            />
          </Form.Item>

          <Form.Item
            // label="Password"
            style={{ display: "block" }}
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              className="loginINput"
              placeholder="Password"
            />
          </Form.Item>

          <Form.Item
            {...tailLayout}
            name="remember"
            valuePropName="checked"
            className="loginCheck"
          >
            <Checkbox style={{ marginLeft: "-130px" }}>Remember me</Checkbox>
            <a href="#" style={{ marginLeft: "130px" }} onClick={showModal2}>
              Create an Account
            </a>
          </Form.Item>

          <Form.Item {...tailLayout} className="btn">
            <Button type="primary" htmlType="submit" className="loginBtn">
              Log in
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      {/* sign up modal */}

      <Modal
        id="loginModal"
        title="Sign Up"
        visible={isModalVisible2}
        onOk={handleOk2}
        onCancel={handleCancel2}
      >
        <Form
          {...layout}
          name="basic"
          style={{}}
          initialValues={{ remember: true }}
          className="loginForm"
        >
          <Form.Item
            style={{ display: "block" }}
            name="fname"
            rules={[
              { required: true, message: "Please input your First Name!" },
            ]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              type="text"
              placeholder="First Name"
              className="loginINput"
            />
          </Form.Item>
          <Form.Item
            // label="Username"
            style={{ display: "block" }}
            name="lname"
            rules={[
              { required: true, message: "Please input your Last Name!" },
            ]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              type="text"
              placeholder="Last Name"
              className="loginINput"
            />
          </Form.Item>
          <Form.Item
            // label="Username"
            style={{ display: "block" }}
            name="username"
            rules={[{ required: true, message: "Please input your username!" }]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              type="text"
              placeholder="Username"
              className="loginINput"
            />
          </Form.Item>

          <Form.Item
            // label="Password"
            style={{ display: "block" }}
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              className="loginINput"
              placeholder="Password"
            />
          </Form.Item>

          <Form.Item
            // label="Password"
            style={{ display: "block" }}
            name="cpassword"
            rules={[
              {
                required: true,
                message: "Please input your Confrim password!",
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              className="loginINput"
              placeholder="Confrim Password"
            />
          </Form.Item>

          <Form.Item
            {...tailLayout}
            name="remember"
            valuePropName="checked"
            className="loginCheck"
          >
            <a href="#" style={{ marginLeft: "130px" }} onClick={showModal}>
              Have an Account
            </a>
          </Form.Item>

          <Form.Item {...tailLayout} className="btn">
            <Button type="primary" htmlType="submit" className="loginBtn">
              Sign up
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
export default Header;
